import firebase from 'firebase/app'
import "firebase/firestore"
import "firebase/database"
import "firebase/auth"
import "firebase/storage"
import "firebase/analytics"

/*const { REACT_APP_APIKEY, 
    REACT_APP_AUTHDOMAIN, 
    REACT_APP_DB, 
    REACT_APP_PID, 
    REACT_APP_SB,
    REACT_APP_SID,
    REACT_APP_APPID } = process.env;*/

const config = { 
    apiKey: "AIzaSyCRsIdUTmHkyYYoSIYnBbAUYPehFkXtmR0",
    authDomain: "digital-giveaways-group.firebaseapp.com",
    databaseURL: "https://digital-giveaways-group.firebaseio.com",
    projectId: "digital-giveaways-group",
    storageBucket: "digital-giveaways-group.appspot.com",
    messagingSenderId: "562781875158",
    appId: "1:562781875158:web:73022fc157aa89f48fd277",
    measurementId: "G-7ZKZCRH2ZH"
};

firebase.initializeApp(config);

export const databaseRef = firebase.database().ref();

export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const storage = firebase.storage();
firebase.analytics();
/*const userRef = databaseRef.child("users/" + "userID1").set({
    email: "user1@test.com",
    birth: "1990-08-16",
    zip: "03060",
    prize: "TBR2001_0001"
});*/

const provider = new firebase.auth.GoogleAuthProvider();

provider.setCustomParameters({
    promt: "select_account",
});

export const createUserProfileDocument =async (userAuth: any) => {
    if(userAuth) return;

    const userReference = firestore.doc('users/${userAuth.uid}');
    const snapShot = await userReference.get();
    if(!snapShot.exists) {
        const {displayName, email} = userAuth;
        const createdAt = new Date();
        try {
            await userReference.set({
                displayName,
                email,
                createdAt
            });
        } catch (error) {
            console.log(error);
        }
    }

    return userReference;
}

//export const signInWithGoogle = () => auth.signInWithPopup(provider);

export const singInAnonymous = () => auth.signInAnonymously();

export default firebase;